// The facts live in JSON so the Node build scripts (sitemap, llms-full,
// robots) can require the same file the bundle imports.
import identity from "./identity.json";

export const SITE_URL = identity.siteUrl;
export const PERSON_NAME = identity.personName;
export const TWITTER_HANDLE = identity.twitterHandle;
export const SOCIAL = identity.social;
/** Profiles that identify the person in JSON-LD `sameAs`. */
export const SAME_AS = [SOCIAL.github, SOCIAL.linkedin];
export const PROFILE_IMAGE = `${SITE_URL}${identity.profileImagePath}`;
/** Share image for pages without their own cover; must exist in public/. */
export const DEFAULT_OG_IMAGE = `${SITE_URL}${identity.defaultOgImagePath}`;
